import { render, staticRenderFns } from "./popup-choose-source.vue?vue&type=template&id=0a4091f3&scoped=true"
import script from "./popup-choose-source.vue?vue&type=script&lang=js"
export * from "./popup-choose-source.vue?vue&type=script&lang=js"
import style0 from "./popup-choose-source.vue?vue&type=style&index=0&id=0a4091f3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a4091f3",
  null
  
)

export default component.exports